/* eslint-disable import/no-cycle */
import React from "react";
import Close from "@pixel/assets/icons/Close";
import Box from "../Box";
import Drawer from "../Drawer";
import { styled, useTheme } from "../styles";
import IconButton from "../IconButton";
import Typography from "../Typography";
import Divider from "../Divider";
import DrawerFormsActions from "./DrawerFormsActions";
import ErrorBoundary from "../ErrorBoundary";
import ActionGroup from "../ActionGroup";
export const DrawerHeader = styled("div")(_ref => {
  let {
    theme
  } = _ref;
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2, 2),
    ...theme.mixins.toolbar
  };
});
export const DrawerFooter = styled("div")(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    bottom: theme.spacing(0),
    "& > div": {
      display: "flex",
      alignItems: "center",
      justifyContent: "right",
      padding: theme.spacing(3, 3)
    }
  };
});
const DrawerStyles = {
  "& .MuiDrawer-paper": {
    height: "100%"
  },
  "@media (max-width: 768px)": {
    "& .MuiDrawer-paper": {
      width: '100%'
    }
  },
  "& ::-webkit-scrollbar": {
    width: "0px",
    background: "transparent"
  }
};
const DrawerContainerStyles = {
  overflow: 'auto',
  height: '100%',
  paddingLeft: 3,
  paddingRight: 3
};
const DrawerForms = _ref3 => {
  let {
    anchor,
    open,
    children,
    onSaveForm,
    onCancel,
    SelectedActionGroupProps,
    drawerWidth = '40%',
    labelDrawerForm = "Drawer Forms",
    labelSaveDrawerForm = "Save",
    labelClose = "Cancel"
  } = _ref3;
  const theme = useTheme();
  const DrawerHeaderActionsStyles = {
    float: 'left',
    width: theme.spacing(5.625)
  };
  const handleClose = e => {
    onCancel(e);
  };
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(React.Fragment, {
    key: anchor
  }, /*#__PURE__*/React.createElement(Drawer, {
    sx: {
      ...DrawerStyles,
      '& .MuiDrawer-paper': {
        width: drawerWidth
      }
    },
    anchor: anchor,
    open: open,
    onClose: handleClose
  }, /*#__PURE__*/React.createElement(DrawerHeader, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    noWrap: true
  }, labelDrawerForm)), /*#__PURE__*/React.createElement(Box, null, SelectedActionGroupProps && /*#__PURE__*/React.createElement(Box, {
    sx: DrawerHeaderActionsStyles
  }, /*#__PURE__*/React.createElement(ActionGroup, SelectedActionGroupProps)), /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": labelClose,
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(Close, null)))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Box, {
    sx: DrawerContainerStyles
  }, children), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DrawerFooter, null, /*#__PURE__*/React.createElement(DrawerFormsActions, {
    onSaveContentModal: onSaveForm,
    onClose: handleClose,
    labelSaveDrawerForm: labelSaveDrawerForm,
    labelClose: labelClose
  }))))));
};
export default DrawerForms;